import React, { Component } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { createStyles, withStyles } from '@material-ui/core/styles';

import AdUnitTabAdParams from './AdUnitTabAdParams';
import AdUnitTabAdvanced from './AdUnitTabAdvanced';
import AdUnitTabSettings from './AdUnitTabSettings';

const styles = createStyles({
  fields: {
    paddingTop: 5,
    paddingLeft: 25,
    paddingRight: 25
  },
  divContainer: {
    margin: 20,
    padding: 20
  }
});

type Props = {
  lookupProperties: string[],
  adSizes: string[],
  expand: boolean,
  index: number,
  item: string,
  record: any
};

type StateProps = {
  value: number
};

class AdUnitBody extends Component<Props, StateProps> {
  state = { value: 0 };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    return (
      <div style={{ display: this.props.expand ? 'initial' : 'none' }}>
        <AppBar position="static">
          <Tabs value={this.state.value} onChange={this.handleChange}>
            <Tab label="Settings" />
            <Tab label="Ad Properties" />
            <Tab label="Advanced" />
          </Tabs>
        </AppBar>
        {this.state.value === 0 &&
          <AdUnitTabSettings
            adSizes={this.props.adSizes}
            item={this.props.item}
            record={this.props.record}
          />}
        {this.state.value === 1 &&
          <AdUnitTabAdParams
            index={this.props.index}
            item={this.props.item}
            lookupProperties={this.props.lookupProperties}
            record={this.props.record} />}
        {this.state.value === 2 &&
          <AdUnitTabAdvanced
            index={this.props.index}
            item={this.props.item}
            record={this.props.record} />}
      </div>
    )
  }
};

export default withStyles(styles)(AdUnitBody);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnitBody.tsx